import React, { useEffect } from 'react';
import AttendanceReportDataTable from '../../Legalreports/AttendanceReport';
import WorkdayReportDataTable from '../../Legalreports/WorkdayReportDataTable';
import AttendanceDetailReportDataTable from '../../AttendanceDetailReport/AttendanceDetailReportDataTable';
import MissingTimeReportDataTable from '../../MissingTimeReport/MissingTimeReportDataTable';
import OvertimeRecordReportDataTable from '../../OvertimeReports/OvertimeRecordReportDataTable';
import AttendanceSheetReportDataTable from '../../AttendanceSheetReport/AttendanceSheetReportDataTable';
import AttendanceRecordReportDataTable from '../../AttendanceReports/AttendanceRecordReportDataTable';
import SimpleReportDataTable from '../../SimpleReports/SimpleReportDataTable';
import ShiftSummaryReportDataTable from '../../ShiftSummaryReports/ShiftSummaryReportDataTable';
import { markingsColumns, MarkingsReport } from '../../../components/CompanyReport';

const ShowReports = ({ moreData, setMoreData, filters, dateRange, reportKey }) => {
  const renderReport = () => {
    switch (reportKey) {
      case 'attendance-report':
        return (
          <AttendanceReportDataTable
            rrhh
            moreData={moreData}
            setMoreData={setMoreData}
            filters={filters}
            dateRange={dateRange}
            isBoss
          />
        );
      case 'workday-report':
        return (
          <WorkdayReportDataTable
            rrhh
            moreData={moreData}
            setMoreData={setMoreData}
            bossFilters={filters}
            dateRange={dateRange}
            isBoss
          />
        );
      case 'attendance-detail-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <AttendanceDetailReportDataTable
                rrhh
                moreData={moreData}
                setMoreData={setMoreData}
                filters={filters}
                dateRange={dateRange}
                isBoss
              />
            </div>
          </>
        );
      case 'missing-time-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <MissingTimeReportDataTable
                rrhh
                bossFilters={filters}
                dateRange={dateRange}
                isBoss
                resource="MissingTimeReport"
              />
            </div>
          </>
        );
      case 'overtime-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <OvertimeRecordReportDataTable rrhh bossFilters={filters} dateRange={dateRange} isBoss />;
            </div>
          </>
        );
      case 'attendance-sheet-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <AttendanceSheetReportDataTable
                rrhh
                moreData={moreData}
                setMoreData={setMoreData}
                filters={filters}
                dateRange={dateRange}
                isBoss
              />
            </div>
          </>
        );
      case 'attendance-record-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <AttendanceRecordReportDataTable
                rrhh
                moreData={moreData}
                setMoreData={setMoreData}
                filters={filters}
                dateRange={dateRange}
                isBoss
              />
            </div>
          </>
        );
      case 'simple-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <SimpleReportDataTable rrhh filters={filters} dateRange={dateRange} isBoss />
            </div>
          </>
        );
      case 'shift-summary-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <ShiftSummaryReportDataTable rrhh filters={filters} dateRange={dateRange} isBoss />
            </div>
          </>
        );
      case 'marking-report':
        return (
          <>
            <div className="company-reports-wrapper">
              <MarkingsReport
                moreData={moreData}
                setMoreData={setMoreData}
                filters={filters}
                dateRange={dateRange}
                isBoss
                columns={markingsColumns}
              />
            </div>
          </>
        );
      default:
        return 'No se puede mostrar el reporte seleccionado';
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return renderReport();
};
export default ShowReports;
